var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#EAA72A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.407 7.18927L12.8162 5.65305L11.8796 5.40441L11.4812 6.90015C11.235 6.83479 10.9821 6.77281 10.7307 6.71138L11.1319 5.20579L10.1958 4.95716L9.7864 6.49284C9.58253 6.44312 9.3824 6.394 9.1882 6.34256L7.89772 5.99425L7.63194 6.99301C7.63194 6.99301 8.32706 7.16353 8.31218 7.17319C8.6915 7.27406 8.7564 7.52674 8.74177 7.72602L8.27568 9.47612C8.30182 9.48321 8.33568 9.49337 8.37294 9.50893C8.34173 9.50068 8.30838 9.4916 8.27397 9.48278L7.62067 11.9344C7.57227 12.0492 7.45147 12.2206 7.1863 12.1507C7.19546 12.1644 6.50555 11.9697 6.50555 11.9697L6.022 13.037L7.2408 13.3606C7.46754 13.4211 7.68968 13.4842 7.9084 13.5438L7.49493 15.0976L8.43044 15.3462L8.8399 13.809C9.09536 13.8825 9.34341 13.9505 9.58617 14.0148L9.17816 15.5449L10.1147 15.7935L10.5282 14.2426C12.1267 14.5706 13.3343 14.4672 13.8643 13.0273C14.2915 11.8679 13.8727 11.1888 13.036 10.7371C13.6525 10.6053 14.1216 10.209 14.258 9.37752C14.4464 8.24168 13.5878 7.6161 12.407 7.18927ZM12.0628 12.3517C11.754 13.5129 9.79799 12.852 9.1631 12.6841L9.71168 10.6255C10.3466 10.7943 12.3855 11.1407 12.0628 12.3517ZM12.4009 9.33166C12.1192 10.3879 10.4914 9.82363 9.96265 9.68325L10.46 7.81624C10.9887 7.95661 12.6942 8.22983 12.4009 9.33166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.4e9c521b.svg";
export { ForwardRef as ReactComponent };